import { useState } from 'react'
import {
  prepareFirstDetailList,
  prepareSecondDetailList,
  programDetailList,
} from '../../../../constants/kdt-aos-4th'
import styles from './kdt-aos-4th.module.scss'

interface IProgramProps {
  detailList: {
    id: number
    step?: string
    title: string
    contents: {
      contentsIntro?: string
      contentsInner?: string
    }[]
  }[]
}

const ProgramTab = ({ detailList }: IProgramProps) => {
  const [value, setValue] = useState(detailList[0]?.id)

  const onClickTab = (id: number) => {
    setValue(id)
  }

  const selectedDetail = detailList.find(detail => detail.id === value)

  const getHeaderText = () => {
    if (detailList === prepareFirstDetailList) {
      return '코딩테스트반 과정'
    }

    if (detailList === prepareSecondDetailList) {
      return '코딩테스트반 수업 구성'
    }

    if (detailList === programDetailList) {
      return (
        <>
          <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
            4
          </span>
          3단계 취업 지원 프로그램
        </>
      )
    }

    return 'Program Details'
  }

  return (
    <div className="flex w-full">
      <div className="w-[604px] shrink-0 px-[100px] py-[90px]">
        <ul className={`${styles.curriculum_accordion_dot_ul} flex flex-col gap-3`}>
          {detailList.map(detail => (
            <li key={detail.id} className="flex flex-row items-center gap-8">
              <div
                className={`${
                  value === detail.id
                    ? 'border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                    : 'border-gray-400 bg-trueGray-800'
                } z-10 h-3 w-3 rounded-full border-[2px]`}
              ></div>
              <div
                className={`${
                  value === detail.id
                    ? 'border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                    : 'border-[#2B2B2B] bg-[#2B2B2B]'
                } flex flex-1 cursor-pointer flex-col gap-1 rounded border px-5 py-4`}
                onClick={() => onClickTab(detail.id)}
              >
                {detail.step && (
                  <p className="text-base font-bold text-yellow-450">{detail.step}</p>
                )}
                <h6
                  className={`${
                    value === detail.id ? 'text-white' : 'text-label-alternative'
                  } whitespace-pre-line text-xl font-bold leading-snug`}
                >
                  {detail.title}
                </h6>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex-1 py-7 pl-12 pr-8">
        <h6 className="flex flex-row items-center gap-2 text-lg font-bold text-white lg:mb-6 lg:gap-[18px] lg:text-2xl">
          {getHeaderText()}
        </h6>
        {selectedDetail && (
          <div className="w-full">
            <h6 className="text-2xl font-bold text-white lg:mb-6">{selectedDetail.title}</h6>
            <div className="flex flex-col rounded bg-[#1F1F1F] px-6 py-1">
              {selectedDetail.contents.map(content => (
                <div
                  className="flex flex-col gap-2 border-t border-[#2E2E2E] py-5 first:border-none"
                  key={content.contentsInner}
                >
                  {content.contentsIntro && (
                    <p className="text-base font-semibold text-white">{content.contentsIntro}</p>
                  )}
                  <p
                    className={`${
                      detailList === prepareSecondDetailList || detailList === programDetailList
                        ? styles['program_text_dot']
                        : ''
                    } text-base text-label-assistive`}
                  >
                    {content.contentsInner}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProgramTab
